var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 9.99996V6.24998M10 12.7795V12.8124M17.5 5.31248L17.5 14.6875C17.5 16.2408 16.2408 17.5 14.6875 17.5H5.3125C3.7592 17.5 2.5 16.2408 2.5 14.6875V5.31248C2.5 3.75919 3.7592 2.5 5.3125 2.5H14.6875C16.2408 2.5 17.5 3.75919 17.5 5.31248Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSquare);
export default __webpack_public_path__ + "static/media/alert-square.a787362c331bac217d1e816e6d4f7dee.svg";
export { ForwardRef as ReactComponent };